import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why react-hook-form is my new favorite form library",
  "description": "",
  "published": "2020-08-03T00:00:00.000Z",
  "redirect_from": ["/blog/why-react-hook-form-is-my-new-favorite-form-library/swizec/9467"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1596468655693.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Forms are fun. They start simple then blow up in your face.`}</p>
    <p>{`You've seen this pattern in every React tutorial with form fields:`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/jovial-khorana-63819"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4415de90d73213aea0469e5c887927e7/ca0a1/techletter.app-screenshot-1596468655693.webp 223w", "/static/4415de90d73213aea0469e5c887927e7/75680/techletter.app-screenshot-1596468655693.webp 445w", "/static/4415de90d73213aea0469e5c887927e7/8d1ba/techletter.app-screenshot-1596468655693.webp 890w", "/static/4415de90d73213aea0469e5c887927e7/3838e/techletter.app-screenshot-1596468655693.webp 1335w", "/static/4415de90d73213aea0469e5c887927e7/e11e5/techletter.app-screenshot-1596468655693.webp 1780w", "/static/4415de90d73213aea0469e5c887927e7/0a0f4/techletter.app-screenshot-1596468655693.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4415de90d73213aea0469e5c887927e7/e92b6/techletter.app-screenshot-1596468655693.png 223w", "/static/4415de90d73213aea0469e5c887927e7/e66bf/techletter.app-screenshot-1596468655693.png 445w", "/static/4415de90d73213aea0469e5c887927e7/4ef49/techletter.app-screenshot-1596468655693.png 890w", "/static/4415de90d73213aea0469e5c887927e7/4e814/techletter.app-screenshot-1596468655693.png 1335w", "/static/4415de90d73213aea0469e5c887927e7/701e9/techletter.app-screenshot-1596468655693.png 1780w", "/static/4415de90d73213aea0469e5c887927e7/bb052/techletter.app-screenshot-1596468655693.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4415de90d73213aea0469e5c887927e7/4ef49/techletter.app-screenshot-1596468655693.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20%5BfirstName%2C%20setFirstName%5D%20%3D%20useState(%22%22)%3B%0A%0A%2F%2F%20...%0A%3Cinput%0A%20%20name%3D%22firstName%22%0A%20%20value%3D%7BfirstName%7D%0A%20%20onChange%3D%7Bevent%20%3D%3E%20setFirstName(event.target.value)%7D%0A%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "58.29596412556054%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'234\\'%20viewBox=\\'0%200%20400%20234\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037l-1%2082%201%2080h351v-80l-1-82c-2-2-348-2-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fb84069d9b019b013cc5654ad43a8dd8/ca0a1/techletter.app-screenshot-1596468638815.webp 223w", "/static/fb84069d9b019b013cc5654ad43a8dd8/75680/techletter.app-screenshot-1596468638815.webp 445w", "/static/fb84069d9b019b013cc5654ad43a8dd8/8d1ba/techletter.app-screenshot-1596468638815.webp 890w", "/static/fb84069d9b019b013cc5654ad43a8dd8/55b8e/techletter.app-screenshot-1596468638815.webp 1068w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fb84069d9b019b013cc5654ad43a8dd8/e92b6/techletter.app-screenshot-1596468638815.png 223w", "/static/fb84069d9b019b013cc5654ad43a8dd8/e66bf/techletter.app-screenshot-1596468638815.png 445w", "/static/fb84069d9b019b013cc5654ad43a8dd8/4ef49/techletter.app-screenshot-1596468638815.png 890w", "/static/fb84069d9b019b013cc5654ad43a8dd8/d53ff/techletter.app-screenshot-1596468638815.png 1068w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fb84069d9b019b013cc5654ad43a8dd8/4ef49/techletter.app-screenshot-1596468638815.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A controlled input. Gets value from state, updates value on change. Works great 👍`}</p>
    <p>{`Keeping form values in state is convenient for business logic. You trigger a re-render for every keypress but that's okay, React is fast.`}</p>
    <p>{`Then you add more fields ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/hardcore-colden-viz62"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/372ef983188bdd852df179c9646613e0/ca0a1/techletter.app-screenshot-1596468654063.webp 223w", "/static/372ef983188bdd852df179c9646613e0/75680/techletter.app-screenshot-1596468654063.webp 445w", "/static/372ef983188bdd852df179c9646613e0/8d1ba/techletter.app-screenshot-1596468654063.webp 890w", "/static/372ef983188bdd852df179c9646613e0/3838e/techletter.app-screenshot-1596468654063.webp 1335w", "/static/372ef983188bdd852df179c9646613e0/e11e5/techletter.app-screenshot-1596468654063.webp 1780w", "/static/372ef983188bdd852df179c9646613e0/0a0f4/techletter.app-screenshot-1596468654063.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/372ef983188bdd852df179c9646613e0/e92b6/techletter.app-screenshot-1596468654063.png 223w", "/static/372ef983188bdd852df179c9646613e0/e66bf/techletter.app-screenshot-1596468654063.png 445w", "/static/372ef983188bdd852df179c9646613e0/4ef49/techletter.app-screenshot-1596468654063.png 890w", "/static/372ef983188bdd852df179c9646613e0/4e814/techletter.app-screenshot-1596468654063.png 1335w", "/static/372ef983188bdd852df179c9646613e0/701e9/techletter.app-screenshot-1596468654063.png 1780w", "/static/372ef983188bdd852df179c9646613e0/bb052/techletter.app-screenshot-1596468654063.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/372ef983188bdd852df179c9646613e0/4ef49/techletter.app-screenshot-1596468654063.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20const%20%5BfirstName%2C%20setFirstName%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5BlastName%2C%20setLastName%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Baddress1%2C%20setAddress1%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Baddress2%2C%20setAddress2%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Bcity%2C%20setCity%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Bzip%2C%20setZip%5D%20%3D%20useState(%22%22)%3B%0A%20%20const%20%5Bstate%2C%20setState%5D%20%3D%20useState(%22%22)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.64125560538116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'238\\'%20viewBox=\\'0%200%20400%20238\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040l-1%2080c0%2077%200%2079%202%2080h344c2-1%202-3%202-80l-1-80c-2-2-344-2-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4c0311d54e3cedc2a4473674885f52ff/ca0a1/techletter.app-screenshot-1596468638949.webp 223w", "/static/4c0311d54e3cedc2a4473674885f52ff/75680/techletter.app-screenshot-1596468638949.webp 445w", "/static/4c0311d54e3cedc2a4473674885f52ff/8d1ba/techletter.app-screenshot-1596468638949.webp 890w", "/static/4c0311d54e3cedc2a4473674885f52ff/6257a/techletter.app-screenshot-1596468638949.webp 988w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4c0311d54e3cedc2a4473674885f52ff/e92b6/techletter.app-screenshot-1596468638949.png 223w", "/static/4c0311d54e3cedc2a4473674885f52ff/e66bf/techletter.app-screenshot-1596468638949.png 445w", "/static/4c0311d54e3cedc2a4473674885f52ff/4ef49/techletter.app-screenshot-1596468638949.png 890w", "/static/4c0311d54e3cedc2a4473674885f52ff/e4900/techletter.app-screenshot-1596468638949.png 988w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4c0311d54e3cedc2a4473674885f52ff/4ef49/techletter.app-screenshot-1596468638949.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That sure blew up 😅`}</p>
    <p>{`State up the wazoo, re-renders on any field change, and you haven't even thought about validation, error states, dirty states, and all the rest that goes into a form.`}</p>
    <p>{`You're smart and you can make this work. I know you can {{ subscriber.first_name | truncatewords: 1, "" | capitalize }}.`}</p>
    <p>{`But imagine a monster form like I was dealing with last week.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1288627385990918144"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "136.32286995515693%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'545\\'%20viewBox=\\'0%200%20400%20545\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%209c-8%205-12%2015-8%2019v4c0%201%204%202%204%200l-1-3c-1-2-1-2%202-2%205%200%208-6%205-10-1-1-1-1%202-1%202%200%203%200%202%204%200%205%201%207%206%207%202-1%203-1%202%201%200%202%202%203%202%201l3-1c2%200%203-1%203-2l2-2c2%200%203-2%201-6s-4-6-6-6l-2-1c0-4-12-6-17-2m16%20275l1%20176%209%201%2011%202c6%204%2024%204%20151%204%20128-1%20129-1%20136-4l10-2h8V110H36v174\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7473d7ed568215e72021ab08999223c8/ca0a1/techletter.app-screenshot-1596468640544.webp 223w", "/static/7473d7ed568215e72021ab08999223c8/75680/techletter.app-screenshot-1596468640544.webp 445w", "/static/7473d7ed568215e72021ab08999223c8/8d1ba/techletter.app-screenshot-1596468640544.webp 890w", "/static/7473d7ed568215e72021ab08999223c8/7f3f2/techletter.app-screenshot-1596468640544.webp 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7473d7ed568215e72021ab08999223c8/e92b6/techletter.app-screenshot-1596468640544.png 223w", "/static/7473d7ed568215e72021ab08999223c8/e66bf/techletter.app-screenshot-1596468640544.png 445w", "/static/7473d7ed568215e72021ab08999223c8/4ef49/techletter.app-screenshot-1596468640544.png 890w", "/static/7473d7ed568215e72021ab08999223c8/8ae78/techletter.app-screenshot-1596468640544.png 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7473d7ed568215e72021ab08999223c8/4ef49/techletter.app-screenshot-1596468640544.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`😇`}</p>
    <h2 {...{
      "id": "custom-form-generators-help"
    }}>{`Custom form generators help`}</h2>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/why-you-should-build-a-form-generator/swizec/9394"
      }}>{`build a form generator`}</a>{` to remove the repetitive work.`}</p>
    <p>{`Helper component, a loop or two, and off you go, right?`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Input%20%3D%20(%7B%20name%2C%20value%2C%20setValue%2C%20placeholder%20%7D)%20%3D%3E%20(%0A%20%20%3Cinput%0A%20%20%20%20name%3D%7Bname%7D%0A%20%20%20%20value%3D%7Bvalue%7D%0A%20%20%20%20placeholder%3D%7Bplaceholder%7D%0A%20%20%20%20onChange%3D%7Bevent%20%3D%3E%20setValue(event.target.value)%7D%0A%20%20%2F%3E%0A)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-2%202-3%20147-1%20149s352%202%20354%200%201-147-1-149c-2-3-350-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0c012cfeb867f9932f667a12893921b4/ca0a1/techletter.app-screenshot-1596468638431.webp 223w", "/static/0c012cfeb867f9932f667a12893921b4/75680/techletter.app-screenshot-1596468638431.webp 445w", "/static/0c012cfeb867f9932f667a12893921b4/8d1ba/techletter.app-screenshot-1596468638431.webp 890w", "/static/0c012cfeb867f9932f667a12893921b4/d8c59/techletter.app-screenshot-1596468638431.webp 1148w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0c012cfeb867f9932f667a12893921b4/e92b6/techletter.app-screenshot-1596468638431.png 223w", "/static/0c012cfeb867f9932f667a12893921b4/e66bf/techletter.app-screenshot-1596468638431.png 445w", "/static/0c012cfeb867f9932f667a12893921b4/4ef49/techletter.app-screenshot-1596468638431.png 890w", "/static/0c012cfeb867f9932f667a12893921b4/e6c84/techletter.app-screenshot-1596468638431.png 1148w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0c012cfeb867f9932f667a12893921b4/4ef49/techletter.app-screenshot-1596468638431.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/friendly-hypatia-j27ck"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a41856081a23d79a1c3c0f88947b8d73/ca0a1/techletter.app-screenshot-1596468654418.webp 223w", "/static/a41856081a23d79a1c3c0f88947b8d73/75680/techletter.app-screenshot-1596468654418.webp 445w", "/static/a41856081a23d79a1c3c0f88947b8d73/8d1ba/techletter.app-screenshot-1596468654418.webp 890w", "/static/a41856081a23d79a1c3c0f88947b8d73/3838e/techletter.app-screenshot-1596468654418.webp 1335w", "/static/a41856081a23d79a1c3c0f88947b8d73/e11e5/techletter.app-screenshot-1596468654418.webp 1780w", "/static/a41856081a23d79a1c3c0f88947b8d73/0a0f4/techletter.app-screenshot-1596468654418.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a41856081a23d79a1c3c0f88947b8d73/e92b6/techletter.app-screenshot-1596468654418.png 223w", "/static/a41856081a23d79a1c3c0f88947b8d73/e66bf/techletter.app-screenshot-1596468654418.png 445w", "/static/a41856081a23d79a1c3c0f88947b8d73/4ef49/techletter.app-screenshot-1596468654418.png 890w", "/static/a41856081a23d79a1c3c0f88947b8d73/4e814/techletter.app-screenshot-1596468654418.png 1335w", "/static/a41856081a23d79a1c3c0f88947b8d73/701e9/techletter.app-screenshot-1596468654418.png 1780w", "/static/a41856081a23d79a1c3c0f88947b8d73/bb052/techletter.app-screenshot-1596468654418.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a41856081a23d79a1c3c0f88947b8d73/4ef49/techletter.app-screenshot-1596468654418.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Ok I didn't use loops, but you get the idea.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{` component is generic and we pass-in state and setters from above. Then you can add errors, default values, different styles, etc.`}</p>
    <p>{`You don't want to push state handling into the `}<inlineCode parentName="p">{`Input`}</inlineCode>{` component itself. That's a recipe for pain.`}</p>
    <p>{`A better approach might be to turn form state into an object and build a reducer.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/recursing-bogdan-i2c4x"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/66073cf6c0c2db4f6028612eabccb219/ca0a1/techletter.app-screenshot-1596468655220.webp 223w", "/static/66073cf6c0c2db4f6028612eabccb219/75680/techletter.app-screenshot-1596468655220.webp 445w", "/static/66073cf6c0c2db4f6028612eabccb219/8d1ba/techletter.app-screenshot-1596468655220.webp 890w", "/static/66073cf6c0c2db4f6028612eabccb219/3838e/techletter.app-screenshot-1596468655220.webp 1335w", "/static/66073cf6c0c2db4f6028612eabccb219/e11e5/techletter.app-screenshot-1596468655220.webp 1780w", "/static/66073cf6c0c2db4f6028612eabccb219/0a0f4/techletter.app-screenshot-1596468655220.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/66073cf6c0c2db4f6028612eabccb219/e92b6/techletter.app-screenshot-1596468655220.png 223w", "/static/66073cf6c0c2db4f6028612eabccb219/e66bf/techletter.app-screenshot-1596468655220.png 445w", "/static/66073cf6c0c2db4f6028612eabccb219/4ef49/techletter.app-screenshot-1596468655220.png 890w", "/static/66073cf6c0c2db4f6028612eabccb219/4e814/techletter.app-screenshot-1596468655220.png 1335w", "/static/66073cf6c0c2db4f6028612eabccb219/701e9/techletter.app-screenshot-1596468655220.png 1780w", "/static/66073cf6c0c2db4f6028612eabccb219/bb052/techletter.app-screenshot-1596468655220.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/66073cf6c0c2db4f6028612eabccb219/4ef49/techletter.app-screenshot-1596468655220.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20const%20%5B%0A%20%20%20%20%7B%20firstName%2C%20lastName%2C%20address1%2C%20address2%2C%20city%2C%20zip%2C%20state%20%7D%2C%0A%20%20%20%20setState%0A%20%20%5D%20%3D%20useState(%7B%0A%20%20%20%20firstName%3A%20%22%22%2C%0A%20%20%20%20lastName%3A%20%22%22%2C%0A%20%20%20%20address1%3A%20%22%22%2C%0A%20%20%20%20address2%3A%20%22%22%2C%0A%20%20%20%20city%3A%20%22%22%2C%0A%20%20%20%20zip%3A%20%22%22%2C%0A%20%20%20%20state%3A%20%22%22%0A%20%20%7D)%3B%0A%0A%20%20function%20valueSetter(name)%20%7B%0A%20%20%20%20return%20value%20%3D%3E%0A%20%20%20%20%20%20setState(formState%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20...formState%2C%0A%20%20%20%20%20%20%20%20%20%20%5Bname%5D%3A%20value%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%20%20%7D)%3B%0A%20%20%7D%0A%20%20%0A%20%20%2F%2F%20...%0A%20%20%0A%20%20%3CInput%0A%20%20%20%20%20%20name%3D%22lastName%22%0A%20%20%20%20%20%20value%3D%7BlastName%7D%0A%20%20%20%20%20%20setValue%3D%7BvalueSetter(%22lastName%22)%7D%0A%20%20%20%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "112.55605381165918%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'450\\'%20viewBox=\\'0%200%20400%20450\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2032l-1%20188v187H0v43h401v-43h-21V220l-1-188c-2-2-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/240174f9a1ad8de8143dafa7b06c829e/ca0a1/techletter.app-screenshot-1596468638930.webp 223w", "/static/240174f9a1ad8de8143dafa7b06c829e/75680/techletter.app-screenshot-1596468638930.webp 445w", "/static/240174f9a1ad8de8143dafa7b06c829e/8d1ba/techletter.app-screenshot-1596468638930.webp 890w", "/static/240174f9a1ad8de8143dafa7b06c829e/4ef06/techletter.app-screenshot-1596468638930.webp 1260w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/240174f9a1ad8de8143dafa7b06c829e/e92b6/techletter.app-screenshot-1596468638930.png 223w", "/static/240174f9a1ad8de8143dafa7b06c829e/e66bf/techletter.app-screenshot-1596468638930.png 445w", "/static/240174f9a1ad8de8143dafa7b06c829e/4ef49/techletter.app-screenshot-1596468638930.png 890w", "/static/240174f9a1ad8de8143dafa7b06c829e/78612/techletter.app-screenshot-1596468638930.png 1260w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/240174f9a1ad8de8143dafa7b06c829e/4ef49/techletter.app-screenshot-1596468638930.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Your form state lives inside an object – one key per field. You can always see current state and you always know what's going on.`}</p>
    <p>{`For easy updates you've got the `}<inlineCode parentName="p">{`valueSetter`}</inlineCode>{` method that returns a function to update a single field.`}</p>
    <p>{`Works great 👍`}</p>
    <p>{`You're triggering a full re-render for every field change, you don't have validations, no way to show errors, and no way to know when a field is dirty.`}</p>
    <p><em parentName="p">{`PS: dirty fields are fields that changed and the value hasn't been saved yet`}</em></p>
    <p><img parentName="p" {...{
        "src": "/7fe317fb95ed8a11bcc936a40e2a7eb1/media-mcH0upG1TeEak-giphy.gif",
        "alt": "loser giphy"
      }}></img></p>
    <h2 {...{
      "id": "react-hook-form-makes-everything-better"
    }}>{`react-hook-form makes everything better`}</h2>
    <p><a parentName="p" {...{
        "href": "https://react-hook-form.com/"
      }}>{`react-hook-form`}</a>{` solves those problems for you.`}</p>
    <p>{`It's a hook-based form solution that takes care of:`}</p>
    <ul>
      <li parentName="ul">{`managing state`}</li>
      <li parentName="ul">{`errors`}</li>
      <li parentName="ul">{`dirty fields`}</li>
      <li parentName="ul">{`validations`}</li>
    </ul>
    <p><em parentName="p">{`And`}</em>{` minimizes re-renders by avoiding controlled inputs.`}</p>
    <p>{`Yep, react-hook-form uses the fields themselves to keep state. Pulls it out when you need it.`}</p>
    <p>{`Here's the example above built with react-hook-form:`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/staging-lake-gg7zm"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ce08dbb04de54cd209b337bc0151667c/ca0a1/techletter.app-screenshot-1596468653651.webp 223w", "/static/ce08dbb04de54cd209b337bc0151667c/75680/techletter.app-screenshot-1596468653651.webp 445w", "/static/ce08dbb04de54cd209b337bc0151667c/8d1ba/techletter.app-screenshot-1596468653651.webp 890w", "/static/ce08dbb04de54cd209b337bc0151667c/3838e/techletter.app-screenshot-1596468653651.webp 1335w", "/static/ce08dbb04de54cd209b337bc0151667c/e11e5/techletter.app-screenshot-1596468653651.webp 1780w", "/static/ce08dbb04de54cd209b337bc0151667c/0a0f4/techletter.app-screenshot-1596468653651.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ce08dbb04de54cd209b337bc0151667c/e92b6/techletter.app-screenshot-1596468653651.png 223w", "/static/ce08dbb04de54cd209b337bc0151667c/e66bf/techletter.app-screenshot-1596468653651.png 445w", "/static/ce08dbb04de54cd209b337bc0151667c/4ef49/techletter.app-screenshot-1596468653651.png 890w", "/static/ce08dbb04de54cd209b337bc0151667c/4e814/techletter.app-screenshot-1596468653651.png 1335w", "/static/ce08dbb04de54cd209b337bc0151667c/701e9/techletter.app-screenshot-1596468653651.png 1780w", "/static/ce08dbb04de54cd209b337bc0151667c/bb052/techletter.app-screenshot-1596468653651.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ce08dbb04de54cd209b337bc0151667c/4ef49/techletter.app-screenshot-1596468653651.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`State management turns into this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20%7B%20register%2C%20handleSubmit%20%7D%20%3D%20useForm()%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "40.35874439461883%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'161\\'%20viewBox=\\'0%200%20400%20161\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2043c-2%202-2%2075%200%2077s340%202%20342%200%202-75%200-77-340-2-342%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ef92dbeaad50488f09e795d222073dd/ca0a1/techletter.app-screenshot-1596468638585.webp 223w", "/static/7ef92dbeaad50488f09e795d222073dd/75680/techletter.app-screenshot-1596468638585.webp 445w", "/static/7ef92dbeaad50488f09e795d222073dd/8d1ba/techletter.app-screenshot-1596468638585.webp 890w", "/static/7ef92dbeaad50488f09e795d222073dd/c3b05/techletter.app-screenshot-1596468638585.webp 924w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ef92dbeaad50488f09e795d222073dd/e92b6/techletter.app-screenshot-1596468638585.png 223w", "/static/7ef92dbeaad50488f09e795d222073dd/e66bf/techletter.app-screenshot-1596468638585.png 445w", "/static/7ef92dbeaad50488f09e795d222073dd/4ef49/techletter.app-screenshot-1596468638585.png 890w", "/static/7ef92dbeaad50488f09e795d222073dd/9a1cf/techletter.app-screenshot-1596468638585.png 924w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7ef92dbeaad50488f09e795d222073dd/4ef49/techletter.app-screenshot-1596468638585.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Setting up a field turns into this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Input%20%3D%20(%7B%20name%2C%20register%20%7D)%20%3D%3E%20(%0A%09%3Cinput%20name%3D%7Bname%7D%20ref%3D%7Bregister%7D%20%2F%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "844px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.466367713004495%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'210\\'%20viewBox=\\'0%200%20400%20210\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2047c-3%203-3%20115%200%20118%202%202%203%202%20168%202s166%200%20168-2c3-3%203-115%200-118S35%2044%2032%2047\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/958db5e1410f5851c3add307477fd70b/ca0a1/techletter.app-screenshot-1596468638643.webp 223w", "/static/958db5e1410f5851c3add307477fd70b/75680/techletter.app-screenshot-1596468638643.webp 445w", "/static/958db5e1410f5851c3add307477fd70b/20d15/techletter.app-screenshot-1596468638643.webp 844w"],
                "sizes": "(max-width: 844px) 100vw, 844px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/958db5e1410f5851c3add307477fd70b/e92b6/techletter.app-screenshot-1596468638643.png 223w", "/static/958db5e1410f5851c3add307477fd70b/e66bf/techletter.app-screenshot-1596468638643.png 445w", "/static/958db5e1410f5851c3add307477fd70b/33e10/techletter.app-screenshot-1596468638643.png 844w"],
                "sizes": "(max-width: 844px) 100vw, 844px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/958db5e1410f5851c3add307477fd70b/33e10/techletter.app-screenshot-1596468638643.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The `}<inlineCode parentName="p">{`register`}</inlineCode>{` method returns a React ref and sets up the form machinery.`}</p>
    <p>{`And when you're ready to submit, values come as an object with a key for every field.`}</p>
    <p><img parentName="p" {...{
        "src": "/cacb8b2018af744b78e30339b7c4868a/media-26FLdmIp6wJr91JAI-giphy.gif",
        "alt": "love giphy"
      }}></img></p>
    <p>{`You get HTML5 validations out of the box. They show up in the `}<inlineCode parentName="p">{`errors`}</inlineCode>{` object. Like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/shy-leftpad-c82j0"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2047e03e9f70234238cd41bbf37a68b9/ca0a1/techletter.app-screenshot-1596468835077.webp 223w", "/static/2047e03e9f70234238cd41bbf37a68b9/75680/techletter.app-screenshot-1596468835077.webp 445w", "/static/2047e03e9f70234238cd41bbf37a68b9/8d1ba/techletter.app-screenshot-1596468835077.webp 890w", "/static/2047e03e9f70234238cd41bbf37a68b9/3838e/techletter.app-screenshot-1596468835077.webp 1335w", "/static/2047e03e9f70234238cd41bbf37a68b9/e11e5/techletter.app-screenshot-1596468835077.webp 1780w", "/static/2047e03e9f70234238cd41bbf37a68b9/0a0f4/techletter.app-screenshot-1596468835077.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2047e03e9f70234238cd41bbf37a68b9/e92b6/techletter.app-screenshot-1596468835077.png 223w", "/static/2047e03e9f70234238cd41bbf37a68b9/e66bf/techletter.app-screenshot-1596468835077.png 445w", "/static/2047e03e9f70234238cd41bbf37a68b9/4ef49/techletter.app-screenshot-1596468835077.png 890w", "/static/2047e03e9f70234238cd41bbf37a68b9/4e814/techletter.app-screenshot-1596468835077.png 1335w", "/static/2047e03e9f70234238cd41bbf37a68b9/701e9/techletter.app-screenshot-1596468835077.png 1780w", "/static/2047e03e9f70234238cd41bbf37a68b9/bb052/techletter.app-screenshot-1596468835077.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2047e03e9f70234238cd41bbf37a68b9/4ef49/techletter.app-screenshot-1596468835077.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Input%20%3D%20(%7B%20name%2C%20register%2C%20errors%2C%20placeholder%20%7D)%20%3D%3E%20(%0A%20%20%3C%3E%0A%20%20%20%20%3Cinput%0A%20%20%20%20%20%20name%3D%7Bname%7D%0A%20%20%20%20%20%20ref%3D%7Bregister(%7B%20minLength%3A%205%20%7D)%7D%0A%20%20%20%20%20%20placeholder%3D%7Bplaceholder%7D%0A%20%20%20%20%2F%3E%0A%20%20%20%20%7Berrors%20%26%26%20%3Cspan%3E%7Bname%7D%20is%20invalid%3C%2Fspan%3E%7D%0A%20%20%3C%2F%3E%0A)%3B%0A%0A%2F%2F%20...%0A%20%20const%20%7B%20register%2C%20handleSubmit%2C%20errors%20%7D%20%3D%20useForm()%3B%0A%20%20%0A%2F%2F%20...%0A%3CInput%20name%3D%22firstName%22%20register%3D%7Bregister%7D%20errors%3D%7Berrors.firstName%7D%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "67.2645739910314%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'269\\'%20viewBox=\\'0%200%20400%20269\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029l-1%20107%201%20106h361V136l-1-107c-2-2-358-2-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab0993622d32cf79aba5bf638b584208/ca0a1/techletter.app-screenshot-1596468638835.webp 223w", "/static/ab0993622d32cf79aba5bf638b584208/75680/techletter.app-screenshot-1596468638835.webp 445w", "/static/ab0993622d32cf79aba5bf638b584208/8d1ba/techletter.app-screenshot-1596468638835.webp 890w", "/static/ab0993622d32cf79aba5bf638b584208/3838e/techletter.app-screenshot-1596468638835.webp 1335w", "/static/ab0993622d32cf79aba5bf638b584208/08aa0/techletter.app-screenshot-1596468638835.webp 1356w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab0993622d32cf79aba5bf638b584208/e92b6/techletter.app-screenshot-1596468638835.png 223w", "/static/ab0993622d32cf79aba5bf638b584208/e66bf/techletter.app-screenshot-1596468638835.png 445w", "/static/ab0993622d32cf79aba5bf638b584208/4ef49/techletter.app-screenshot-1596468638835.png 890w", "/static/ab0993622d32cf79aba5bf638b584208/4e814/techletter.app-screenshot-1596468638835.png 1335w", "/static/ab0993622d32cf79aba5bf638b584208/229ad/techletter.app-screenshot-1596468638835.png 1356w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ab0993622d32cf79aba5bf638b584208/4ef49/techletter.app-screenshot-1596468638835.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`By default validations run on change.`}</p>
    <p><img parentName="p" {...{
        "src": "/d5871b8b4c37f4f2747fecd3ff681f60/8OoC3l4.gif",
        "alt": null
      }}></img></p>
    <p>{`And you can change that with a line of code 😍`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20%7B%20register%2C%20handleSubmit%2C%20errors%20%7D%20%3D%20useForm(%7B%0A%09mode%3A%20'onBlur'%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.04932735426009%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'171\\'%20viewBox=\\'0%200%20400%20171\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2038l-1%2049c0%2045%200%2047%202%2048h346c2-1%202-3%202-48l-1-49c-2-2-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0fb37aed786733711cbd86a2d8aac742/ca0a1/techletter.app-screenshot-1596468638418.webp 223w", "/static/0fb37aed786733711cbd86a2d8aac742/75680/techletter.app-screenshot-1596468638418.webp 445w", "/static/0fb37aed786733711cbd86a2d8aac742/8d1ba/techletter.app-screenshot-1596468638418.webp 890w", "/static/0fb37aed786733711cbd86a2d8aac742/fcad6/techletter.app-screenshot-1596468638418.webp 1036w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0fb37aed786733711cbd86a2d8aac742/e92b6/techletter.app-screenshot-1596468638418.png 223w", "/static/0fb37aed786733711cbd86a2d8aac742/e66bf/techletter.app-screenshot-1596468638418.png 445w", "/static/0fb37aed786733711cbd86a2d8aac742/4ef49/techletter.app-screenshot-1596468638418.png 890w", "/static/0fb37aed786733711cbd86a2d8aac742/0d1a4/techletter.app-screenshot-1596468638418.png 1036w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0fb37aed786733711cbd86a2d8aac742/4ef49/techletter.app-screenshot-1596468638418.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><img parentName="p" {...{
        "src": "/36f580a33143455a4a3c7ee632bb25eb/DnFojjm.gif",
        "alt": null
      }}></img></p>
    <h3 {...{
      "id": "add-context-for-more-flexibility"
    }}>{`Add context for more flexibility`}</h3>
    <p>{`Passing errors and registers into every field like above is silly. Too much work.`}</p>
    <p>{`That's why react-hook-form supports context.`}</p>
    <p>{`Using the same approach as my `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/wormhole-state-management/swizec/9442"
      }}>{`Wormhole state management`}</a>{` article:`}</p>
    <ul>
      <li parentName="ul">{`create a form`}</li>
      <li parentName="ul">{`put everything in context`}</li>
      <li parentName="ul">{`wormhole to context with a hook`}</li>
    </ul>
    <p>{`You get form components that magically connect to your form. Register themselves, know about errors, dirty states. Everything 😍`}</p>
    <p>{`Like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/optimistic-euclid-46ifb"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e646fe80d1d81ddb6dd63ba1425e6c04/ca0a1/techletter.app-screenshot-1596468652847.webp 223w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/75680/techletter.app-screenshot-1596468652847.webp 445w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/8d1ba/techletter.app-screenshot-1596468652847.webp 890w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/3838e/techletter.app-screenshot-1596468652847.webp 1335w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/e11e5/techletter.app-screenshot-1596468652847.webp 1780w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/0a0f4/techletter.app-screenshot-1596468652847.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e646fe80d1d81ddb6dd63ba1425e6c04/e92b6/techletter.app-screenshot-1596468652847.png 223w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/e66bf/techletter.app-screenshot-1596468652847.png 445w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/4ef49/techletter.app-screenshot-1596468652847.png 890w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/4e814/techletter.app-screenshot-1596468652847.png 1335w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/701e9/techletter.app-screenshot-1596468652847.png 1780w", "/static/e646fe80d1d81ddb6dd63ba1425e6c04/bb052/techletter.app-screenshot-1596468652847.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e646fe80d1d81ddb6dd63ba1425e6c04/4ef49/techletter.app-screenshot-1596468652847.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20Input%20%3D%20(%7B%20name%2C%20placeholder%20%7D)%20%3D%3E%20%7B%0A%20%20const%20%7B%20register%2C%20errors%20%7D%20%3D%20useFormContext()%3B%0A%0A%20%20return%20(%0A%20%20%20%20%3C%3E%0A%20%20%20%20%20%20%3Cinput%0A%20%20%20%20%20%20%20%20name%3D%7Bname%7D%0A%20%20%20%20%20%20%20%20ref%3D%7Bregister(%7B%20minLength%3A%202%20%7D)%7D%0A%20%20%20%20%20%20%20%20placeholder%3D%7Bplaceholder%7D%0A%20%20%20%20%20%20%2F%3E%0A%20%20%20%20%20%20%7Berrors%5Bname%5D%20%26%26%20%3Cspan%3E%7Bname%7D%20is%20invalid%3C%2Fspan%3E%7D%0A%20%20%20%20%3C%2F%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "78.47533632286996%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'315\\'%20viewBox=\\'0%200%20400%20315\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037c-1%202-2%20240%200%20242%201%202%20349%202%20350%200%202-2%201-240%200-242-2-2-348-2-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/227a80b1c6e7df09749820b150981d40/ca0a1/techletter.app-screenshot-1596468638708.webp 223w", "/static/227a80b1c6e7df09749820b150981d40/75680/techletter.app-screenshot-1596468638708.webp 445w", "/static/227a80b1c6e7df09749820b150981d40/8d1ba/techletter.app-screenshot-1596468638708.webp 890w", "/static/227a80b1c6e7df09749820b150981d40/55b8e/techletter.app-screenshot-1596468638708.webp 1068w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/227a80b1c6e7df09749820b150981d40/e92b6/techletter.app-screenshot-1596468638708.png 223w", "/static/227a80b1c6e7df09749820b150981d40/e66bf/techletter.app-screenshot-1596468638708.png 445w", "/static/227a80b1c6e7df09749820b150981d40/4ef49/techletter.app-screenshot-1596468638708.png 890w", "/static/227a80b1c6e7df09749820b150981d40/d53ff/techletter.app-screenshot-1596468638708.png 1068w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/227a80b1c6e7df09749820b150981d40/4ef49/techletter.app-screenshot-1596468638708.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Every field validates a 2 character `}<inlineCode parentName="p">{`minLength`}</inlineCode>{` and displays its own errors.`}</p>
    <p><img parentName="p" {...{
        "src": "/e579e789b6758e824e8d44286d852bdb/t10OP3q.gif",
        "alt": null
      }}></img></p>
    <p>{`Using them in a form looks easy now:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3CInput%20name%3D%22firstName%22%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "620px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'240\\'%20viewBox=\\'0%200%20400%20240\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M43%2064c-3%203-3%20110%200%20114l2%203h310l2-3c3-4%203-111%200-114l-2-2H45l-2%202m20%2021c-2%203-3%205-1%208%204%207%2013%205%2013-3%200-6-7-9-12-5m26%200c-5%205-1%2013%205%2013%204%200%208-4%208-8%200-6-9-10-13-5m26%200c-5%204-2%2013%205%2013%203%200%207-3%207-6%201-6-2-9-7-9l-5%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7b3d09140ac68617601c90bd8302bdab/ca0a1/techletter.app-screenshot-1596468638827.webp 223w", "/static/7b3d09140ac68617601c90bd8302bdab/75680/techletter.app-screenshot-1596468638827.webp 445w", "/static/7b3d09140ac68617601c90bd8302bdab/cf77e/techletter.app-screenshot-1596468638827.webp 620w"],
                "sizes": "(max-width: 620px) 100vw, 620px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7b3d09140ac68617601c90bd8302bdab/e92b6/techletter.app-screenshot-1596468638827.png 223w", "/static/7b3d09140ac68617601c90bd8302bdab/e66bf/techletter.app-screenshot-1596468638827.png 445w", "/static/7b3d09140ac68617601c90bd8302bdab/2a195/techletter.app-screenshot-1596468638827.png 620w"],
                "sizes": "(max-width: 620px) 100vw, 620px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7b3d09140ac68617601c90bd8302bdab/2a195/techletter.app-screenshot-1596468638827.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><img parentName="p" {...{
        "src": "/dcb2a3eb1330123ffefb7ec76a56910b/media-UO5elnTqo4vSg-giphy.gif",
        "alt": "excited giphy"
      }}></img></p>
    <h3 {...{
      "id": "add-yup-for-big-validations"
    }}>{`Add Yup for big validations`}</h3>
    <p>{`You've got the machinery to spit out forms now. Small schlep and you're done.`}</p>
    <p>{`Render a form, pepper it with `}<inlineCode parentName="p">{`<Input name="X" />`}</inlineCode>{` fields and voila. Happy boss, happy customer, happy you.`}</p>
    <p>{`And then it's time for real validations. Not `}<inlineCode parentName="p">{`minLength`}</inlineCode>{` or `}<inlineCode parentName="p">{`required`}</inlineCode>{`. `}<em parentName="p">{`Real`}</em>{` validations. The kind where `}<inlineCode parentName="p">{`lastName`}</inlineCode>{` is required, but only if `}<inlineCode parentName="p">{`firstName`}</inlineCode>{` is filled in.`}</p>
    <p><img parentName="p" {...{
        "src": "/8ce99ba22f17d162d891e8d197302dfa/media-13YroVUrUrLCec-giphy-downsized-medium.gif",
        "alt": "gulp giphy"
      }}></img></p>
    <p>{`You can add `}<a parentName="p" {...{
        "href": "https://github.com/jquense/yup"
      }}>{`yup`}</a>{` for that. react-hook-form supports it out of the box ✌️`}</p>
    <p>{`Here's the example above that validates you wrote the whole address, but only if you wrote the street name.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/dreamy-rain-xoc5s"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-4l1-4%2047-1h48v6a482%20482%200%20004-95V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4e0e42aa0c5193b357595223c9935177/ca0a1/techletter.app-screenshot-1596468656833.webp 223w", "/static/4e0e42aa0c5193b357595223c9935177/75680/techletter.app-screenshot-1596468656833.webp 445w", "/static/4e0e42aa0c5193b357595223c9935177/8d1ba/techletter.app-screenshot-1596468656833.webp 890w", "/static/4e0e42aa0c5193b357595223c9935177/3838e/techletter.app-screenshot-1596468656833.webp 1335w", "/static/4e0e42aa0c5193b357595223c9935177/e11e5/techletter.app-screenshot-1596468656833.webp 1780w", "/static/4e0e42aa0c5193b357595223c9935177/0a0f4/techletter.app-screenshot-1596468656833.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4e0e42aa0c5193b357595223c9935177/e92b6/techletter.app-screenshot-1596468656833.png 223w", "/static/4e0e42aa0c5193b357595223c9935177/e66bf/techletter.app-screenshot-1596468656833.png 445w", "/static/4e0e42aa0c5193b357595223c9935177/4ef49/techletter.app-screenshot-1596468656833.png 890w", "/static/4e0e42aa0c5193b357595223c9935177/4e814/techletter.app-screenshot-1596468656833.png 1335w", "/static/4e0e42aa0c5193b357595223c9935177/701e9/techletter.app-screenshot-1596468656833.png 1780w", "/static/4e0e42aa0c5193b357595223c9935177/bb052/techletter.app-screenshot-1596468656833.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4e0e42aa0c5193b357595223c9935177/4ef49/techletter.app-screenshot-1596468656833.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><img parentName="p" {...{
        "src": "/10c5a472b83187848bf734920ffb02f7/SrY8mvc.gif",
        "alt": null
      }}></img></p>
    <p>{`To make that happen you 👇`}</p>
    <p>{`Write a Yup schema describing the shape of your data. Bit of an art to it, make sure you don't fall off the deep end with conditional validations. They get tricky.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20schema%20%3D%20yup.object().shape(%7B%0A%20%20firstName%3A%20yup.string()%2C%0A%20%20lastName%3A%20yup.string()%2C%0A%20%20address1%3A%20yup.string()%2C%0A%20%20address2%3A%20yup.string()%2C%0A%20%20city%3A%20yup.string().when(%22address1%22%2C%20%7B%0A%20%20%20%20is%3A%20address1%20%3D%3E%20address1.length%20%3E%200%2C%0A%20%20%20%20then%3A%20yup.string().required()%0A%20%20%7D)%2C%0A%20%20state%3A%20yup.string().when(%22address1%22%2C%20%7B%0A%20%20%20%20is%3A%20address1%20%3D%3E%20address1.length%20%3E%200%2C%0A%20%20%20%20then%3A%20yup.string().required()%0A%20%20%7D)%2C%0A%20%20zip%3A%20yup.string().when(%22address1%22%2C%20%7B%0A%20%20%20%20is%3A%20address1%20%3D%3E%20address1.length%20%3E%200%2C%0A%20%20%20%20then%3A%20yup.string().required()%0A%20%20%7D)%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "844px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "116.59192825112108%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'466\\'%20viewBox=\\'0%200%20400%20466\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2047c-2%202-2%203-2%20187l1%20187c3%203%20335%203%20338%200l1-187c0-184%200-185-2-187-3-3-333-3-336%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/56ce74f4f4cd88456711cf2c6ec8f227/ca0a1/techletter.app-screenshot-1596468638837.webp 223w", "/static/56ce74f4f4cd88456711cf2c6ec8f227/75680/techletter.app-screenshot-1596468638837.webp 445w", "/static/56ce74f4f4cd88456711cf2c6ec8f227/20d15/techletter.app-screenshot-1596468638837.webp 844w"],
                "sizes": "(max-width: 844px) 100vw, 844px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/56ce74f4f4cd88456711cf2c6ec8f227/e92b6/techletter.app-screenshot-1596468638837.png 223w", "/static/56ce74f4f4cd88456711cf2c6ec8f227/e66bf/techletter.app-screenshot-1596468638837.png 445w", "/static/56ce74f4f4cd88456711cf2c6ec8f227/33e10/techletter.app-screenshot-1596468638837.png 844w"],
                "sizes": "(max-width: 844px) 100vw, 844px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/56ce74f4f4cd88456711cf2c6ec8f227/33e10/techletter.app-screenshot-1596468638837.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The Yup docs are `}<em parentName="p">{`okay`}</em>{`, not stellar. I recommend tinkering until it works.`}</p>
    <p>{`Then you tell react-hook-form about your schema:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20const%20formMethods%20%3D%20useForm(%7B%0A%20%20%20%20mode%3A%20%22onChange%22%2C%0A%20%20%20%20resolver%3A%20yupResolver(schema)%0A%20%20%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "732px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.47085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'262\\'%20viewBox=\\'0%200%20400%20262\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M39%2053c-4%201-4%200-4%2080v76l2%201c4%203%20322%203%20326%200l2-1v-76l-1-79a12447%2012447%200%2000-325-2m17%2019c-4%201-5%207-2%209%203%204%2010%201%2010-4%200-3-4-7-8-5m19%201c-3%203-3%205%200%208%204%205%2011%203%2011-3s-7-9-11-5m22%200c-3%203-3%206%200%209s5%203%208%200c4-3%204-6%201-9s-6-3-9%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/46358c26933950b886bfa7d20f430a83/ca0a1/techletter.app-screenshot-1596468638535.webp 223w", "/static/46358c26933950b886bfa7d20f430a83/75680/techletter.app-screenshot-1596468638535.webp 445w", "/static/46358c26933950b886bfa7d20f430a83/a0372/techletter.app-screenshot-1596468638535.webp 732w"],
                "sizes": "(max-width: 732px) 100vw, 732px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/46358c26933950b886bfa7d20f430a83/e92b6/techletter.app-screenshot-1596468638535.png 223w", "/static/46358c26933950b886bfa7d20f430a83/e66bf/techletter.app-screenshot-1596468638535.png 445w", "/static/46358c26933950b886bfa7d20f430a83/d0cc0/techletter.app-screenshot-1596468638535.png 732w"],
                "sizes": "(max-width: 732px) 100vw, 732px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/46358c26933950b886bfa7d20f430a83/d0cc0/techletter.app-screenshot-1596468638535.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And change your `}<inlineCode parentName="p">{`register`}</inlineCode>{` call back to vanilla:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cinput%20name%3D%7Bname%7D%20ref%3D%7Bregister%7D%20placeholder%3D%7Bplaceholder%7D%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "30.94170403587444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'124\\'%20viewBox=\\'0%200%20400%20124\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2034v58c1%201%2022%202%20178%202s177-1%20178-2V34c-2-3-354-3-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f11748aac6a1a7fc563895f236b0bf1e/ca0a1/techletter.app-screenshot-1596468638504.webp 223w", "/static/f11748aac6a1a7fc563895f236b0bf1e/75680/techletter.app-screenshot-1596468638504.webp 445w", "/static/f11748aac6a1a7fc563895f236b0bf1e/8d1ba/techletter.app-screenshot-1596468638504.webp 890w", "/static/f11748aac6a1a7fc563895f236b0bf1e/31d32/techletter.app-screenshot-1596468638504.webp 1196w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f11748aac6a1a7fc563895f236b0bf1e/e92b6/techletter.app-screenshot-1596468638504.png 223w", "/static/f11748aac6a1a7fc563895f236b0bf1e/e66bf/techletter.app-screenshot-1596468638504.png 445w", "/static/f11748aac6a1a7fc563895f236b0bf1e/4ef49/techletter.app-screenshot-1596468638504.png 890w", "/static/f11748aac6a1a7fc563895f236b0bf1e/51800/techletter.app-screenshot-1596468638504.png 1196w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f11748aac6a1a7fc563895f236b0bf1e/4ef49/techletter.app-screenshot-1596468638504.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you've got reusable field components that work with any form. Pop them in, set the schema, get validations and error handling and all the rest.`}</p>
    <p><img parentName="p" {...{
        "src": "/a7639535d75aa03e8a21a5d980c5f5ee/media-xUPGcyuPRNjODvvOFO-giphy.gif",
        "alt": "peace giphy"
      }}></img></p>
    <p>{`Happy hacking`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: in my code I went as far as a generic `}<inlineCode parentName="p">{`<Form>`}</inlineCode>{` component that sets up the context provider and `}<inlineCode parentName="p">{`<form>`}</inlineCode>{` element for me.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      